<div class="modal-header py-2">
    <h2 class="mb-0">Pause subscription</h2>
    <span class="icon icon-cross ml-auto py-1 px-2" (click)="cancel()"></span>
</div>

<div class="modal-body">
    <div [formGroup]="pauseCyclesForm">
        <div class="col-xs-4 pt-2 mt-1">
            <label for="pause-cycles" class="col-xs-8 control-label">Number of billing cycles to pause</label>
            <input
                type="number"
                class="form-control"
                id="pause-cycles"
                pattern="[0-9]*"
                formControlName="pauseCycles"
                name="servicesSettingsLabel"
            />
        </div>
        <div class="pt-2 mt-1" *ngIf="pauseText" [innerText]="pauseText"></div>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary mr-2"
        angularticsCategory="account"
        angulartics2On="click"
        angularticsAction="Confirm pause subscription"
        type="submit"
        [disabled]="inProgress || pauseCyclesForm.invalid"
        (click)="pause()"
    >Confirm</button>
    <button type="button" class="btn btn-danger" [disabled]="inProgress" (click)="cancel()">Cancel</button>
</div>
